import {
  BadRequestError,
  ApiResponse,
  UnprocessableEntityError
} from "@/api/types";
import { getErrorMessageFromIwebErrorCode } from "@/helpers/iweb-helper";

export function getErrorMessages(
  error: BadRequestError | UnprocessableEntityError
) {
  return error.response.data.errors.flatMap((item: ApiResponse.ErrorData) => {
    if (item.error_code !== undefined && item.error_code !== null) {
      // エラーレスポンスにerror_codeが存在する場合はi-web連携設定のエラーとして取り扱う
      return [getErrorMessageFromIwebErrorCode(item.error_code)];
    } else {
      return item.messages;
    }
  });
}
